import React from 'react';
import { Link } from 'react-router-dom';
import { ComingSoonPage } from '@components/ui/pages';
import { useAuditEnabled } from '@features/jotaudit';
import { Button } from '@mui/material';
import { useEventTracking } from '@services/statsig';
import { salesBookingUrl } from '@utils/salesBooking';

import { useTracking } from '../../../context/TrackingContext';
import { EventType } from '../../../types/events';

const LEARN_MORE_URL = salesBookingUrl('bill-insurance');

/**
 * BillInsurancePage Component
 *
 * A "coming soon" page for the Bill Insurance feature.
 * Displays information about the upcoming billing insurance feature
 * with CTAs for learning more and accessing rules.
 */
export const BillInsurancePage: React.FC = () => {
  const { billing } = useEventTracking();
  const { trackEvent } = useTracking();
  const isAuditEnabled = useAuditEnabled();

  const handleLearnMoreClick = () => {
    billing.learnMoreClicked({
      destination_url: LEARN_MORE_URL,
    });
    trackEvent(EventType.EXPRESSED_INTEREST, {
      feature: 'bill_insurance',
    });
  };

  const handleRulesClick = () => {
    billing.rulesClicked({
      destination_path: '/rules',
    });
  };

  return (
    <ComingSoonPage
      title="Bill Insurance"
      showHeader={false}
      action={
        isAuditEnabled ? (
          <Button
            component={Link}
            to="/rules"
            variant="contained"
            color="secondary"
            onClick={handleRulesClick}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            Your Rules
          </Button>
        ) : undefined
      }
      heroTitle="Bill Insurance"
      description="Your notes. Our AI + humans. Clean claims, every time."
      primaryAction={{
        label: 'Learn more',
        href: LEARN_MORE_URL,
        external: true,
        onClick: handleLearnMoreClick,
        startIcon: null,
      }}
    />
  );
};
